import { jsx as _jsx } from "react/jsx-runtime";
import { DEFAULT_AUTO_HIDE_DURATION_IN_MILLISECONDS } from "../../../components/atoms/Snackbar/Snackbar.consts.js";
// import components
import Snackbar from "@mui/material/Snackbar";
import Slide from "../../../components/atoms/Slide/index.js";
export const SnackbarAtomComponent = ({ message, action, autoHideDuration, closeDirection, doNotDismissOnClickAway, anchorOrigin = { vertical: "top", horizontal: "right" }, open, onClose, ...props }) => (_jsx(Snackbar, { anchorOrigin: anchorOrigin, open: open, onClose: (event, reason) => {
        if (reason === "clickaway" && doNotDismissOnClickAway) {
            return;
        }
        onClose?.(event, reason);
    }, autoHideDuration: autoHideDuration ?? DEFAULT_AUTO_HIDE_DURATION_IN_MILLISECONDS, message: message, action: action, TransitionComponent: (slideProps) => (_jsx(Slide, { ...slideProps, direction: closeDirection ?? "left" })), "data-testid": "Snackbar", ...props }));
export default SnackbarAtomComponent;
